import styled from 'styled-components';
import QR from '../../atoms/QR/QR';

/**
 * Блок оплаты по QR (CPAYMENT-1637).
 *
 * У QR-реквизита нет номера, который можно скопировать в банк: провайдер отдаёт
 * ссылку, и она приходит в `requisite.paymentUrl`. Поэтому вместо строки с
 * копированием показываем сам код и кнопку перехода — с телефона клиент сканирует,
 * с десктопа открывает ссылку.
 */
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const Hint = styled.p`
  margin: 0;
  text-align: center;
  font-size: 14px;
  line-height: 1.35;
  color: #6b7280;
`;

const GoButton = styled.a<{ $accent: string }>`
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 12px;
  background: ${({ $accent }) => $accent};
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
`;

type Props = {
  url: string;
  hint: string;
  action: string;
  /** Цвет кнопки: у каждого шаблона своя палитра. */
  accent?: string;
  /** Подложка под кодом; по умолчанию белая, чтобы код читался в любой теме. */
  frameColor?: string;
  size?: number;
};

const QrPayBlock = ({
  url,
  hint,
  action,
  accent = '#16a34a',
  frameColor = '#ffffff',
  size = 180,
}: Props) => (
  <Wrap>
    <QR data={url} size={size} bgColor='#ffffff' fgColor='#111111' frameColor={frameColor} />
    <Hint>{hint}</Hint>
    <GoButton $accent={accent} href={url} target='_blank' rel='noopener noreferrer'>
      {action}
    </GoButton>
  </Wrap>
);

export default QrPayBlock;
